<template>
  <div class="page-wrapper">
    <b-row class="text-left d-flex">
      <b-col class="mb-3" sm="12" lg="6">
        <!-- Logo + Nome + Versão -->
        <div class="d-flex mb-5">
          <img
            width="50px"
            src="../assets/central-klaus.svg"
            alt="Logo da Central Klaus"
          />
          <div class="ml-3">
            <span class="titulo">Central Klaus</span>
          </div>
        </div>

        <!-- Descrição do app -->
        <span class="titulo-section">DESCRIÇÃO</span>
        <p class="descricao mt-3">
          Baixe as notas que estão na nuvem Klaus direto para seu computador de
          forma organizada. Simplifique o fechamento fiscal e contábil
        </p>

        <h5>Recursos da Central Klaus</h5>
        <ul class="w-75">
          <li>
            Organização automática das notas baixadas em pastas separadas por
            data, empresa e tipo de participação
          </li>
          <li>
            Download customizável: baixe os tipos de documentos fiscais que te
            interessam no momento, no intervalo de datas que definir
          </li>
          <li>Design otimizado</li>
        </ul>

        <!-- DESCOMENTAR QUANDO HOUVEREM SCREENSHOTS (Não esquecer de alterar os valores do src e do v-pswp das imagens) -->

        <!-- Galeria de screenshots
        <span class="titulo-section">SCREENSHOTS</span>
        <div class="galeria mt-3">
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/central-klaus-1.png')"
              v-pswp="require('../assets/screenshots/central-klaus-1.png')"
            />
          </Photoswipe>
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/central-klaus-2.png')"
              v-pswp="require('../assets/screenshots/central-klaus-2.png')"
            />
          </Photoswipe>
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/central-klaus-3.jpg')"
              v-pswp="require('../assets/screenshots/central-klaus-3.jpg')"
            />
          </Photoswipe>
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/central-klaus-4.png')"
              v-pswp="require('../assets/screenshots/central-klaus-4.png')"
            />
          </Photoswipe>
        </div>  -->
      </b-col>
    </b-row>

    <!-- Modal de download -->
    <modal-download-suite
      @fechar-modal="fecharModal"
      :visibilidade="isModalVisivel"
    />
  </div>
</template>

<script>
import ModalDownloadSuite from "../components/ModalDownloadSuite.vue";
import mixin from "../mixins/mixin";
import "../assets/theme.css";
export default {
  name: "CentralKlaus",
  components: {
    ModalDownloadSuite,
  },
  mixins: [mixin],
};
</script>
